module.exports = __webpack_public_path__ + "static/media/01B.110c681d.png";